const CONSENT_KEY = "btx_cookie_consent";

/**
 * @returns {true|false|null} true/false once a choice was made, null if no choice yet
 */
export function getConsent() {
  try {
    const value = localStorage.getItem(CONSENT_KEY);
    if (value === "accepted") return true;
    if (value === "refused") return false;
    return null;
  } catch (e) {
    return null;
  }
}

export function setConsent(accepted) {
  try {
    localStorage.setItem(CONSENT_KEY, accepted ? "accepted" : "refused");
  } catch (e) {
    // localStorage unavailable (private browsing, etc.): the choice just won't be remembered
  }
}

export function clearAudienceCookies() {
  const cookieNames = document.cookie
    .split(";")
    .map((cookie) => cookie.split("=")[0].trim())
    .filter((name) => name === "_ga" || name.startsWith("_ga_") || name.startsWith("_hj"));
  const hostname = window.location.hostname;
  const domains = ["", hostname, `.${hostname}`];
  const parts = hostname.split(".");
  if (parts.length > 2) domains.push(`.${parts.slice(-2).join(".")}`);

  const pathParts = window.location.pathname.split("/").filter(Boolean);
  const paths = ["/"];
  pathParts.forEach((part, index) => paths.push(`/${pathParts.slice(0, index + 1).join("/")}`));

  cookieNames.forEach((name) => {
    paths.forEach((path) => {
      domains.forEach((domain) => {
        const domainAttribute = domain ? `; Domain=${domain}` : "";
        document.cookie = `${name}=; Path=${path}${domainAttribute}; Max-Age=0; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
      });
    });
  });
}
